import React from "react";
import { preaddStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import { FormSelect } from "../form";

export const AddBankSelectForm = ({
  handleChange,
  bankSelector,
  banksData
}) => {
  const classes = preaddStyles();
  const { t } = useTranslation();

  var PAYEE_TYPE_LIST = banksData?.map(({ id, name }) => (
    { value: id, label: name }
  ))

  return (
    <div className={classes.addSchoolForm}>
      <Grid container className={classes.gridRoot} spacing={2}>
        <Grid item sm={12} xs={12}>
          <FormSelect
            required={true}
            value={bankSelector}
            onChange={handleChange}
            label={"Please select a bank"}
            name={"bankSelector"}
            list={PAYEE_TYPE_LIST}
          />
        </Grid>
      </Grid>
    </div>
  );
};
